import { render, staticRenderFns } from "./ybMedicineDetails.vue?vue&type=template&id=68ee2b8a&scoped=true"
import script from "./ybMedicineDetails.vue?vue&type=script&lang=js"
export * from "./ybMedicineDetails.vue?vue&type=script&lang=js"
import style0 from "./ybMedicineDetails.vue?vue&type=style&index=0&id=68ee2b8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee2b8a",
  null
  
)

export default component.exports